<template>
  <div class="foods-view">
    <div class="column column-left"></div>
    <div class="column column-center"> 
      <h1 id="title">Japanese Foods</h1>
      <div id="intro"> If you ever go to Japan you are going to have eat. Taking over 10,000 steps a day burns a couple
        of calories and the best way to replenish is some 和食(wasyoku) meaning Japanese food. </div>
      <div class="food-container">
        <h3>1. 親子丼 - Oyakodon</h3> 
        <span>Chicken and egg with rice</span>
        <p class="food-main-text">
            This is a Japanese dish that is made up of mostly chicken, egg, and rice. The symbols that make 
            up the word are 親(oya), 子(ko), and 丼(don). In this case 親(oya) refers to the chicken, the "parent" of the egg.
            子(ko), meaning child, refers to the egg. Lastly 丼(don) refers to the bowl it is usually served in. 
        </p>
        <p class="food-main-text">
            親子丼 is made by sauteing onions in 出し(dashi) with the chicken and then cracking the egg 
            in there half way through cooking. All of these ingredients get mixed together to form this delecious gelantious soup mixture
            which is then poured over ご飯(gohan). This is an underated Japanese classic which you  can even make at home. There is even 
            a specialized pan that is specially made to cook this dish.  
        </p>
      </div>
      <div class="food-container">
        <h3>2. ラーメン - Ramen</h3> 
        <span>Noodle soup with an assortment of toppings</span>
        <p class="food-main-text">Everyone's favorite, the steaming bowl of goodness served with magical toppings. If you noticed ラーメン is written
            using katakana, the alphabet used for foreign words. Yes, ラーメン is a foreign in invention. The word has its origin in the chinese 
            word (拉麵) lāmiàn meaning "pulled noodles" in chinese. According to wikipedia ラーメン in Japan orginated from the Chinatown in Yokohama city.
        </p>
        <p class="food-main-text">Ramen is usually made with a rich 醤油(syouyu, meaning soy sauce) broth and a myriad of toppings.</p>
        <h5>具材 - Guzai - Toppings</h5>
        <h6>卵 - Tomago - Egg</h6>
        <h6>葱 - Negi - Green Onion</h6>
        <h6>叉焼 - Cyaasyuu - Roasted Pork Fillet (Often Used In Ramen)</h6>
        <h6>海苔 - Nori - Egg</h6>
        <h6>蒲鉾 - Kamaboko - Fish Cake</h6>
        <h6>麺麻 - Menma - Bamboo shoots</h6>
        <h6>唐揚げ - Karaage - Japanese fried chicken</h6>
        <h6>ニンニク - Ninniku - Garlic</h6>
        <h6 style="margin-top: 20px;">替え玉 - Kaiedama - second serving of noodles (specifically to add to one's remaining ramen broth)</h6>
        <p>One of the great joys in life is ordering additional noodles to eat with your leftover broth.
           <span>Simpily yell "Kaiedama!" to a server and they'll know what to do.</span> 
        </p>        
      </div>
      <div class="food-container">
        <h3>3. お好み焼き - Okonomiyaki</h3> 
        <span>Cabbage pancake with meat, seafood, and various other goodies</span>
        <p class="food-main-text">The word お好み焼き has two parts, お好み(okonomi) meaning "like / how you like it" and 焼き (yaki)
          meaning "fried or cooked". It's called this since there are many variations and ingredients in the pancake and it is usually cooked on a griddle.
          The dish is prepared by mixing a savory wheat batter mixed with shredded cabbage, meat, seafood, cracked egg, and typically served with 
          plenty of mayonnaise. There is even a お好み焼き sauce made up of oyster sauce, sugar, ketchup, and worestchire sauce.
          While popular in Japan the flavor profile may not be for all westerners. Common toppings include bonito flakes, and 青のり(aonori) 
          which is a dried seaweed powder.  
        </p> 
      </div>
      <div class="food-container">
        <h3>4. カツカレー - Katsukaree</h3> 
        <span>Curry Katsu</span>
        <p class="food-main-text">
          Curry Katsu is a dish that refers to a pork cutlet or カツ(katsu) and Curry pronounced <span>カレー(karee).</span>
          This is one of best dishes Japan has to offer. Steaming Curry with a panko deep fried pork cutlet layed upon a bed a rice is truly 
          a must have experience. The Japanese style カレー can come in many different forms but will often have a base of onions, carrots, 
          potatos, and curry roux.
        </p> 
      </div>
      <div class="food-container">
        <h3>5. 鰻 / うなぎ - Unagi</h3>
        <span>Marinated and Grilled Eel</span>
        <p class="food-main-text">
          Another japanese delicacy is 鰻(うなぎ) while the kanji is still in use it is 
          usually written in hiragana. Chefs take years mastering the art of iteratively grilling, and marinating the 
          うなぎ to perfection. Usually the うなぎ is split and skrewered over hot coals and then dunked into a delicious marinade 
          repeatidly until it reaches a perfect inbetween of charred and suculent. It is traditionally served
          over a bowl of rice. 
        </p> 
      </div>
      <div class="food-container">
        <h3>6. たこ焼き - Takoyaki</h3>
        <span>Squid balls</span>
        <p class="food-main-text">
          A popular Japanese street foods is takoyaki which is made by cooking a batter 
          with octopus in a specifc type of pan.
          The word for octopus is たこ(tako), so when combined with 焼き you get something like cooked octopus. 
          After cooking the balls a healthy layer of mayonnaise, Bonito flakes, and seaweed powder are applied. 
          Takoyako is usually eaten with a simple wooden skewer or 箸(hashi) a.k.a chopsticks. 
        </p> 
      </div>
      <div class="food-container">
        <h3>7. 餃子 - Gyoza</h3>
        <span>Dumplings</span>
        <p class="food-main-text">
          Gyoza are a take on Chinese dumplings. 餃(gyo) means dumpling, specifically Chinese dumplings. The second kanji 子(za) means child. So the words together 
          basically mean small dumpling. These Chinese dumplings were brought over during the wartimes and have remained a staple ever since. Theu are often cooked in
          a thing cornstarch and flower mixture that give them a flaky crunchy side. Soy sauce, vinegar, chili oil are often along side these delicious Japanese staple.
        </p> 
      </div>
      <div class="food-container">
        <h3>8. 弁当 - Bento</h3>
        <span>Japanese Lunch meal served in a box</span>
        <p class="food-main-text">
          Most of you know you probaly familiar with what a bento box is. A mixed bag usually consistenting of tempura,
          teriyaki chicken, sushi, rice, gyoza, fish, fruits, vegtables, ect. However bento boxes really don't 
          have a specific set of contents. The eytomology of the word 弁当(bento) is some what complex. The orginal Chinese
          word meant "convenience" and when the word was imported it was written different for the Japanese tongue losing
          its orginal meaning. Currently the character 弁(ben) is associated with speech or dialect and 当(to) has a meaning
          of this / our. But to clear 弁当 means a lunch box despite what the individual characters may mean.
        </p> 
      </div>
      <div class="food-container">
        <h3>9. 洋食 - Yousyouku</h3>
        <span>Western style food</span>
        <p class="food-main-text">
          As Japan was westernized many western dishes and food were introduced to the Japanese diet.
          洋(you) refers to the west, and 食(syouku) literally means food so together you get western food.
          The list of Japanese style western food is endless but here are some staples.
        </p>
        <h5>コロッケ - Korokke - Croquette</h5>
        <p>
          Croquettes are panko coated deep fried pockets of French origin and are usually made 
          of a filling of potatos, onions, carrots, and spices. They can be served with a tonkatsu
          sauce or served by themselves. Some of the best spins on this snack are カレーコロッケ
          which contain a curry filling.
        </p>
        <h5>唐揚げ - Karaage - Fried Chicken</h5>
        <p>
          Technically karaage refers anything that is lightly fried in a batter. However, when you're in Japan 
          karaage almost exclusively refers to dep fried chicken. Fried Chicken is served in a variety of ways:
          as an appetizer, a component of a 弁当, or even as a ラーメン topping. In the appetizer case the Kaarage is 
          usually served with lemon, mayonnaise, and some shredded cabbage. 
        </p>
        <h5>オムライス - Omuraisu - Omelette Rice / Omurice</h5>
        <p>
          The ticktock special omurice, a perfectly cooked omlette served over fried rice and cut down the middle 
          exposing its softly scrabbled inards. This dish is can served with just the egg and rice portions but 
          a sauce is often poured over the top. Not much to say other than うまい!
        </p>
      </div>
      <div class="food-container">
        <h3>10. 懐石 - Kaiseki</h3>
        <span>A multi course meal consisting of a variety of dishes</span>
        <p class="food-main-text">
          Looking for an insane dining experience? Kaisekis provide a not only an amzazing meal but an in depth cultural experience.
          懐(kai) refers to the breast pocket of a shirt or similiar garment and 石(means) stones. The origin of the words comes 
          from a japanese tea ceremonies who's creator drew inspiration from monks placing hot stones near their stomachs to 
          ward off hunger. To ward off your hunger is what a chef would likely serve you.
        </p>
        <h6>先附 - Sakizuke - Appetizer</h6>
        <p></p>
        <h6>八寸 - Hassun - Second Course</h6>
        <p></p>
        <h6>向付 - Mukouzuke - Seasonal Sashimi</h6>
        <p></p>
        <h6>煮合 - Takiawase - Cooked Protein And Vegtables</h6>
        <p></p>
        <h6>蓋物 - Futamono - Covered Dish, Usually a soup</h6>
        <p></p>
        <h6>焼物 - Yakimono - Grilled Dish, Uusually fish</h6>
        <p>Yakimono literally means grilled thing</p>
        <h6>酢肴 - Su-Zakana - Pickled Vegtable Dish For Cleansing Pallet</h6>
        <p>
          Dishes like this are the inspiration for the pickled ginger at most American Restraunts.
        </p>
        <h6>吸い物 - Suimono - Clear borth soup with some accoutrements</h6>
        <h6>冷し鉢 - Hiyashibachi - Summer Dish That Usually Consists of Chilled Vegtables</h6>
        <p></p>
        <h6>中猪口 - nakachoko - Light Pallet Cleanser Usually An Acdic Soup</h6>
        <p></p>
        <h6>強肴 - Shiizakana - Main dish that is typically a hotpot like dish</h6>
        <p></p>
        <h6>御飯 - Gohan - Simpily A Rice Dish</h6>
        <p></p>
        <h6>香の物 - Kounomono - Pickled Vegetables</h6>
        <p></p>
        <h6>止椀 - Tomewan - Miso or Vegtable Based Soup Served With Rice</h6>
        <p></p>
        <h6>水物 - Mizumono - Desert: Fruits, ice cream, mochi, dango, or Cake</h6>
        <p>This words literally means watery thing. It refers to fruit or ice cream
          which to have a higher water content.
        </p>
      </div>
      <div class="food-container">
        <h3>Honorable Mentions</h3>
        <h4>お任せ - Omakase</h4>
        <p class="food-main-text">
          Similiar to Kaiseki Omakase style dinners are multi course meals.
          The main difference is the quality and intention behind the experience.
          任 means obligation and the word お任せ(omakase) translates to "chef's choice" or
          "leaving the decision to you".
          Each dish is handmade in front of you and served to you directly by the chef.
          Many Omakase have specific alchol pairings which match each dish presented to you.
          It is considered a culinary experience and artistic performance.
        </p> 
      </div>
      <Quiz v-if="false" :qn="qn" :style="{}" @fininshQuiz="submitQuiz"/>
      <div id="conclusion">As you begin your journey learning Japanese make sure to practice everyday using Lextend.io. One of keys to learning a new language is consistency, doing a little everyday is better than a lot at once. So with this in mind, keep going on your Japanese language adventure!</div>
    </div>
    <div class="column column-right">
    </div>
    </div>
</template>

<script>
// import Quiz from '../components/Quiz.vue';

export default {
  name: "WordsAndPhrases",
  components: {
  },
  data() {
  },
  methods: {
  
  },
};
</script>

<style scoped>

#conclusion {
  margin-top: 50px;
  margin-bottom: 100px;
}

.food-main-text {
  margin-top: 30px;
}

.food-container {
  margin-top: 30px;
}

#title {
  margin-top: 50px;
}

#intro {
  margin-top: 30px;
}

.foods-view {
  text-align: left;
  font-family: Arial, sans-serif;
  display: flex;
  width: 100%;
}

/* Specific column widths */
.column-left {
  width: 15%; /* Left column occupies 20% */
  /* background-food:  #000080; */
}

.column-center {
  width: 70%; /* Center column occupies 60% */
  padding: 0 50px 0px 50px
}

.column-right {
  width: 15%; /* Right column occupies 20% */
  /* background-food:  #000080; */
}

</style>
